import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedDataService } from "../config/shared-data.service";
import { ApiDataService } from "../api-data.service";
import { FormDataService } from "../data/form-data.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
declare let fbq: Function;
@Component({
  selector: "app-tab-type",
  templateUrl: "./tab-type.component.html",
  styleUrls: ["./tab-type.component.scss"],
})
export class TabTypeComponent implements OnInit, OnDestroy {
  isLoading: boolean = true;
  locationName: string;
  location: object = [];
  isOpenTicket: boolean = false;
  titleLocation: string = "";
  descLocation: string = "";

  availableCourses: Array<any> = [];
  apiData: any = { selectedDate: "", policyAccepted: "" };

  private destroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private formDataService: FormDataService,
    private sharedService: SharedDataService,
    public apiService: ApiDataService,
    private route: ActivatedRoute,
    private router: Router,
    public translateService: TranslateService
  ) {
    this.formDataService.setActiveStep("step_1", true);
    //this.apiData = this.formDataService.getSelectedDate();
    //this.apiData = this.formDataService.getSelectedDate();
    //Clear cart
    this.formDataService.resetCart();
  }

  ngOnInit() {
    this.sharedService.currentMessage
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data) => (this.locationName = data));

    this.route.queryParams
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (params) => {
        this.isOpenTicket = !!params.open_ticket;
        if (params.location) {
          const res = await this.sharedService
            .getLocations()
            .pipe(takeUntil(this.destroyed$))
            .toPromise();

          if (res && res.data) {
            const foundLocation = res.data.locations.find(
              (location) => location.permalink === params.locatio
            );
            if (foundLocation) {
              localStorage.setItem(
                "location_selected",
                JSON.stringify(foundLocation)
              );
            }
          }
        }
      });

    //remove active steps
    this.formDataService.setActiveStep("step_3", false);
    this.formDataService.setActiveStep("step_4", false);

    //get api Data
    this.apiService
      .getCourses()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data) => {
        this.availableCourses = data.available_courses;
        this.isLoading = false;
      });

    let location = localStorage.getItem("location_selected");
    if (location) {
      let lang = localStorage.getItem("language")
        ? localStorage.getItem("language")
        : "it";
      let loc = JSON.parse(location);
      this.titleLocation = loc.translations[lang].booking_title.text;
      this.descLocation = loc.translations[lang].booking_description.text;
    }
  }

  goToNext(course: any) {
    localStorage.setItem("course_selected", JSON.stringify(course));
    this.formDataService.setActiveStep("step_2", true);
    this.router.navigate(["/calendar"], { queryParamsHandling: "merge" });
  }

  private saveStepData(course: any): boolean {
    if (!course) {
      return false;
    }
    this.formDataService.setCourseType(course);
    return true;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
